"use client";

import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const handleMobileLinkClick = () => {
    setIsMobileMenuOpen(false);
  };
  return <div data-section-id="82034" className="container mx-auto px-4 md:px-6 h-20 flex items-center justify-between">
      {}
      <div className="flex-shrink-0 flex items-center">
        <Link to="/HomePage">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/euroindiatrade_logo.png" alt="EuroIndiaTrade Logo" className="h-7 w-auto" />
        </Link>
      </div>

      {}
      <div className="hidden md:flex flex-1 justify-center">
        {loading ? <div className="flex gap-4">
            {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-20 bg-muted animate-pulse rounded" />)}
          </div> : <NavigationMenu viewport={false}>
            <NavigationMenuList className="gap-6">
              {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                  <NavigationMenuLink asChild>
                    <Link to={item.href || "#"} className="group relative py-2 text-sm font-medium font-sans uppercase tracking-wider text-foreground transition-colors hover:text-foreground">
                      {item.label}
                      <span className="absolute bottom-0 left-1/2 h-[2px] w-0 -translate-x-1/2 bg-secondary transition-all duration-300 group-hover:w-full" />
                    </Link>
                  </NavigationMenuLink>
                </NavigationMenuItem>)}
            </NavigationMenuList>
          </NavigationMenu>}
      </div>

      {}
      <div className="flex items-center gap-4">
        <div className="hidden md:block">
          <Button className="animate-pulse hover:animate-none transition-all duration-300 shadow-lg shadow-primary/20 bg-primary text-primary-foreground rounded-sm font-sans font-medium">
            Get Started
          </Button>
        </div>
        
        <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-muted" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle mobile menu">
          {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
        </Button>
      </div>

      {}
      {isMobileMenuOpen && <div className="absolute top-full left-0 w-full bg-background/95 backdrop-blur-md border-b border-border shadow-xl md:hidden flex flex-col py-4 px-4 gap-4 animate-in slide-in-from-top-2 duration-200">
          {loading ? <div className="flex flex-col gap-4">
              {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-8 w-full bg-muted animate-pulse rounded" />)}
            </div> : <nav className="flex flex-col gap-2">
              {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="py-3 px-4 text-base font-medium font-sans uppercase tracking-wide text-foreground hover:bg-muted rounded-md transition-colors" onClick={handleMobileLinkClick}>
                  {item.label}
                </Link>)}
            </nav>}
          <div className="pt-4 border-t border-border mt-2">
            <Button className="w-full animate-pulse hover:animate-none bg-primary text-primary-foreground rounded-sm" size="lg">
              Get Started
            </Button>
          </div>
        </div>}
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (hashPart === '') {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            return;
          }
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <header id="header" className={`sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? "bg-background/80 backdrop-blur-md border-b border-border shadow-sm" : "bg-background border-b border-border"}`}>
      <MenuProvider menu_id="45">
        <HeaderContent />
      </MenuProvider>
    </header>;
}